import { render } from "./InputOptinDaysCondition.vue?vue&type=template&id=2451b8a4"
import script from "./InputOptinDaysCondition.vue?vue&type=script&lang=js"
export * from "./InputOptinDaysCondition.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__